import axiosCommon from '@/axios-common/axios-common';
import InfiniteLoading from 'vue-infinite-loading';
import vSelect from 'vue-select';

export default {
    name: 'generalPublicationDashboard',
    dependencies:['localeService'],
    components: {
        InfiniteLoading,
        vSelect
    },
    mounted() {
        this.initialize()
    },
    data() {
        return {
            generalPublications: [],
            search: {
                months: '',
                years: ''
            },
            months: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December'
            ],
            years: [],
            skip: 0,
            take: 5
        }
    },
    methods: {
        initialize() {
            let vm = this;

            vm.initializeYears();

            return vm.getGeneralPublications()
                .then(function (res) {
                    if (res.data.length > 0) {
                        vm.generalPublications = res.data;
                    }
                })
                .catch(function (err) {
                    console.log(err);
                    return err;
                });
        },
        initializeYears() {
            let vm = this;
            let now = new Date();
            for (let year = now.getFullYear() ; year >= 1900 ; year--) {
                vm.years.push(String(year));
            }
        },

        infiniteHandler($state) {
            let vm = this;
            vm.skip += vm.take;
            vm.getGeneralPublications()
                .then(function (res) {
                    vm.generalPublications = vm.generalPublications.concat(res.data);
                    $state.loaded();
                    if (res.data.length == 0) {
                        $state.complete()
                    }
                })
                .catch(function (err) {
                    console.log(err);
                    return err;
                });

        },
        filter() {
            let vm = this;
            vm.skip = 0;
            vm.take = 0;
            vm.getGeneralPublications()
                .then(function (res) {
                    vm.generalPublications = res.data;
                })
                .catch(function (err) {
                    console.log(err);
                    return err;
                });
        },
        getGeneralPublications() {
            let vm = this;
            return axiosCommon.get(`o/generalPublications?language=${vm.localeService.getCurrentLocale()}&skip=${vm.skip}&take=${vm.take}&months=${vm.search.months.toString()}&years=${vm.search.years.toString()}`)
                .then(function (res) {
                    return res;
                })
                .catch(function (err) {
                    return err;
                });
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/general-publication-dashboard/general-publication-dashboard.js